
export const OBJECTSTORE_TEAMS = "Teams";